import { render } from "./CastellCopy-Modal.vue?vue&type=template&id=413e73bc"
import script from "./CastellCopy-Modal.vue?vue&type=script&lang=js"
export * from "./CastellCopy-Modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__